export const BRAND_COLOR = '#228288'
